import { gql, useMutation } from '@apollo/client';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { UserPermission } from 'src/lib/graphqlTypes/types';

export function useSetMinEditRole(
  setErrorMessage: (value: React.SetStateAction<string | undefined>) => void,
) {
  const [baseSetMinEditRole] = useMutation<
    GraphQLTypes.SetMinEditRole,
    GraphQLTypes.SetMinEditRoleVariables
  >(
    gql`
      mutation SetMinEditRole(
        $collectionId: ID!
        $minEditRole: UserPermission
      ) {
        operationCollection(id: $collectionId) {
          setMinEditRole(editRole: $minEditRole) {
            ... on OperationCollection {
              id
              minEditRole
            }
            ... on Error {
              message
            }
          }
        }
      }
    `,
    { onError: (error) => setErrorMessage(error.message) },
  );

  const setMinEditRole = React.useCallback(
    ({
      collectionId,
      minEditRole,
    }: {
      collectionId: string;
      minEditRole: UserPermission | null;
    }) =>
      baseSetMinEditRole({
        variables: {
          collectionId,
          minEditRole,
        },
      }),
    [baseSetMinEditRole],
  );

  return { setMinEditRole };
}
